import { render, staticRenderFns } from "./AboutYourRelease.vue?vue&type=template&id=2082ebf2&scoped=true&"
import script from "./AboutYourRelease.vue?vue&type=script&lang=ts&"
export * from "./AboutYourRelease.vue?vue&type=script&lang=ts&"
import style0 from "./AboutYourRelease.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AboutYourRelease.vue?vue&type=style&index=1&id=2082ebf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082ebf2",
  null
  
)

export default component.exports